/** Id of the splash screen element rendered in index.html before the application is bootstrapped. */
const SPLASH_ELEMENT_ID = 'app-splash';
/** Class that fades the splash screen out, see the styles in index.html. */
const SPLASH_HIDDEN_CLASS = 'app-splash--hidden';
/** Has to match the transition duration of the splash screen in index.html. */
const SPLASH_FADE_OUT_MS = 300;
/**
 * Minimum time (in ms, counted from the page load) the splash screen stays visible, even when the
 * application is ready earlier. Only there to be able to show the splash screen - set it to 0 to
 * hide the splash screen as soon as the application is ready.
 */
const SPLASH_MINIMUM_VISIBLE_MS = 3000;

/** Fades out and removes the splash screen shown while the application is starting up. */
export function hideAppSplash(): void {
  const splash = document.getElementById(SPLASH_ELEMENT_ID);
  if (!splash) {
    return;
  }

  const remainingTime = Math.max(0, SPLASH_MINIMUM_VISIBLE_MS - performance.now());

  setTimeout(() => {
    splash.classList.add(SPLASH_HIDDEN_CLASS);
    setTimeout(() => splash.remove(), SPLASH_FADE_OUT_MS);
  }, remainingTime);
}
